import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { showAccessDeniedAlert } from "../../../utils/accessDenied"
import RoutesMap from "../../../route_control/RouteControl"
import axios from "axios"

export const donationList = createAsyncThunk('donationList', async ({ id, status, navigate }) => {

    const participant = JSON.parse(localStorage.getItem('user_data'))

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `donation_list`,
            params: {
                'role_id': participant?.role_id,
                'event_id': id,
                'status': status,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + localStorage.getItem('user_token'),
            }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const donationListSlice = createSlice({
    name: 'donationList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(donationList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                localStorage.clear()
                action.meta.arg.navigate(RoutesMap.LOGIN.path)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(donationList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default donationListSlice.reducer; 